import {
  VersicherungsangabenConfig,
  VersicherungsangabenSectionConfig,
} from '@/features/Versicherungsangaben/types';
import { SECTION } from '@/components/layout/types';

const inputConfig: VersicherungsangabenSectionConfig = {
  [SECTION.INPUT_VN]: {
    label: 'Angaben zum Versicherungsnehmer / versicherte Person',
    component: () =>
      import(
        '@/features/Sparten/hun/sections/input/InputVersicherungsnehmer.vue'
      ),
  },
  [SECTION.INPUT_ABSICHERUNG]: {
    label: 'Gewünschte Absicherung',
    component: () =>
      import('@/features/Sparten/hun/sections/input/InputAbsicherung.vue'),
  },
  [SECTION.HUN_INPUT_DOGS]: {
    label: 'Hunde',
    component: () =>
      import('@/features/Sparten/hun/sections/input/InputHunde.vue'),
  },
  [SECTION.INPUT_BEITRAGSREDUZIERUNG]: {
    label: 'Mögliche Beitragsreduzierung',
    disabledPaths: ['demvRabattiert'],
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/input/InputBeitragsreduzierung.vue'
      ),
  },
};

const contractConfig: VersicherungsangabenSectionConfig = {
  [SECTION.CONTRACT_CLIENT]: {
    label: 'Persönliche Angaben',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractClient.vue'
      ),
  },
  // [SECTION.CONTRACT_COMPANY_QUESTION]: {
  //   label: 'Gesellschaftsfragen',
  //   requiresContractTariff: true,
  //   component: () =>
  //     import(
  //       '@/features/Sparten/shared/sections/property/contract/ContractCompanyQuestions.vue'
  //     ),
  // },
  [SECTION.HUN_CONTRACT_DOGS]: {
    label: 'Hunde',
    component: () =>
      import('@/features/Sparten/hun/sections/contract/ContractHunde.vue'),
  },
  [SECTION.PROPERTY_CONTRACT_PREVIOUS_INSURANCE]: {
    label: 'Vorversicherung',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractPreviousInsuranceAndDamage.vue'
      ),
  },
  [SECTION.CONTRACT_BANK_TRANSFER_INFORMATION]: {
    label: 'Zahlungsinformation',
    requiresContractTariff: true,
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractBankTransferInformation.vue'
      ),
  },
};

export const hunVersicherungsangabenConfig: VersicherungsangabenConfig = {
  inputConfig,
  contractConfig,
};
